/* Currently Selectors are split between three main sectors: PlanAhead, SpendSmart and Transactions plus Admin and
 General. This is similar to the current file structure and when adding a new selector you want to
  1) check if there is a similar selector present and reuse it;
  2) if it's new sort it intuitively, depending on where in the code it is present */

/* eslint sort-keys: "error" */
export default {
    Admin: {
        ACCOUNT_TAB: 'accountTab',
        ADMIN_SUBMIT_BUTTON: 'adminSubmitButton',
        ADMIN_SYNC_STATUS_FORM: 'adminSetSyncStatusForm',
        DATA_SNAPSHOT_SELECT: 'dataSnapshotSelect',
        ERROR_STATUS_SELECTOR: 'errorStatusSelector',
        FULL_MFP_CHECKBOX: 'fullMfpCheckbox',
        MAKE_ME_EXISTING_USER: 'makeMeExistingUser',
        MAKE_ME_NEW_USER: 'makeMeNewUser',
        MARK_DONE_TRANSACTION_CLASSIFICATION_WALKME: 'markDoneTransactionClassificationWalkme',
        NEVER_SHOW_CREATE_RULE_PROMPT: 'neverShowCreateRulePrompt',
        ONBOARDING_SELECT: 'onboardingSelect',
        RESET_TRANSACTION_CLASSIFICATION_WALKME: 'resetTransactionClassificationWalkme',
        SAVE_ACCOUNT_ERRORS_BUTTON: 'saveAccountErrorsButton',
        SHOW_CREATE_RULE_PROMPT: 'showCreateRulePrompt',
        SPENDSMART_CHECKBOX: 'spendsmartMicrojourneyCheckbox',
        SYNC_ERROR_ACCOUNT: 'syncErrorAccount',
        TERMS_VERSION_INPUT: 'termsVersionInput',
        USER_TAB: 'userTab'
    },
    General: {
        BACK_BTN: 'backButton',
        BANNER_ANCHOR: 'bannerAnchor',
        BANNER_BODY_TEXT: 'bannerBodyText',
        BASIC_INPUT_ERROR: 'BasicInputError',
        BASIC_INPUT_FIELD: 'BasicInputField',
        BASIC_SEARCH_CLEAR_BUTTON: 'basicSearch-clearButton',
        BASIC_SEARCH_ICON: 'basicSearch-icon',
        BASIC_SEARCH_INPUT: 'basicSearch-input',
        BUTTON: '.button',
        BWs_SLIDER: '.bw-slider',
        CANT_AFFORD: '.error',
        CANVAS: 'canvas',
        CAN_AFFORD: '.success',
        CAN_AFFORD_SAVINGS: '.warning',
        CHOICE_CARD: 'choiceCard',
        CURRENCY_FIELD: '.currency-field',
        CURRENCY_INPUT: 'currencyInput',
        CURRENCY_INPUT_ERROR: 'currencyInputErrpr',
        DISCLOSURES_CONTAINER: '.disclosures',
        DOB_DAY_SELECT: '#dob-day',
        DOB_MONTH_SELECT: '#dob-month',
        DOB_YEAR_INPUT: '#dob-year',
        EMAIL_INPUT: 'emailInput',
        EMPTY_STATE_BOX: 'emptyStateBox',
        END_MONTH_INPUT: 'endDateInput',
        END_YEAR_INPUT: 'endDateInput',
        ERROR_BLOCK: 'errorBlock',
        GOALS_BUTTON: '.goals-button',
        HIDDEN_ALERT: 'hiddenAlert',
        INLINE_ERROR: 'inlineError',
        INLINE_ERROR_RETRY: 'inlineErrorRetry',
        LOADING_INDICATOR: 'loadingIndicator',
        LOGIN_BUTTON: 'loginButton',
        MATERIAL_BUTTON_CONTAINED: '.MuiButton-contained',
        MATERIAL_BUTTON_FOCUSED: '.Mui-focused',
        MATERIAL_H6: '.headingS',
        MATERIAL_TREE_ITEM_ROOT: '.MuiTreeItem-root',
        MENTOR: 'mentor',
        MENTOR_BUTTON_ONE: 'mentorButtonOne',
        MORE_INFO_TOOLTIP: 'moreInfoTooltip',
        MORE_INFO_TOOLTIP_CONTENT: 'div[role="tooltip"]',
        MUI_DIALOG_CONTAINER: '.MuiDialog-container',
        NAME_INPUT: 'nameBasicInput',
        NAV_LINK: 'navLink',
        OPTIONS_BOX_BUTTON: 'optionsBoxButton',
        OUTPUT_CONTAINER: 'outputContainer',
        OUTPUT_CONTAINER_AMOUNT: 'outputContainer-amount',
        PLAID_CONNECT: 'plaidConnect',
        PLAID_RECONNECT_INSTITUTION: 'plaidReconnectInstitution',
        PRIMARY_CHOICE_BUTTON: '.primaryChoiceButton',
        RADIO_BUTTONS: '.radio-buttons',
        SECONDARY_CHOICE_BUTTON: '.secondaryChoiceButton',
        SELECT_CARD_BUTTON: 'selectCardButton',
        SIGNIN_SCREEN: 'signinScreen',
        SIGNUP_BUTTON: 'signupButton',
        START_DATE_MONTH: 'startDateDateInput',
        START_DATE_YEAR: 'startDateDateInput',
        START_MONTH_INPUT: 'startDateInput',
        START_YEAR_INPUT: 'startDateInput',
        SUBMIT: '[type="submit"]',
        SUBMIT_BUTTON: 'submitButton',
        SYNC_BANNER: 'syncBanner',
        SYNC_BANNER_TEST_VALUE: 'syncLoaderTestValue',
        TAB_BUTTON: 'tabButton',
        TERTIARY_BUTTON_MEDIUM_LIGHT: '.bodeButtonTertiaryMediumLight',
        TRY_AGAIN_LINK: 'tryAgainLink',
        UNENROLL_BUTTON: 'unenrollButton',
        UNENROLL_CANCEL_BUTTON: 'unenrollCancelButton',
        UPDATE_BUTTON: 'updateButton',
        WIDE_VIEW_TITLE: 'wideViewTitle'
    },
    PlanAhead: {
        ACCOUNTS_LIST: 'accounts-list',
        ACCOUNT_DRAWER: 'accountDrawer',
        ACCOUNT_LEFT: '.accountsCollapsibleItemInnerLeft',
        ACCOUNT_NAME: 'accountName',
        ACCOUNT_NICKNAME: 'accountNickname',
        ACCOUNT_PICKER: '#emergencyFundAccountPicker',
        ACCOUNT_SELECT: 'account-select',
        ADDITIONAL_EXPENSES_ANCHOR: 'additionalExpensesAnchor',
        ADDITIONAL_MONTHLY_SPENDING: 'additionalMonthlySpendingCurrencyInput',
        ADD_ACCOUNT_BUTTON: '.actionCard button',
        ADD_ACCOUNT_LIST: 'add-account-list',
        ADD_BUDGET: '#add-budget',
        ADD_DEBT_BUTTON: '.debtButton',
        ADD_EDIT_BUTTON: 'addEditButton',
        ADD_INCOME_BUTTON: 'addIncomeButton',
        ADD_PERSON_BUTTON: '.addMoreRow',
        ADD_SAVINGS_GOAL_BUTTON: '.optionsBox button',
        ADJUST_EXPENSES_GOAL: '.adjust-expenses-goal',
        AMOUNT: '.amount',
        BACK_BUTTON: 'onboardingBackButton',
        BAR_CHART_TRANSACTION_LINK: 'barChartTransactionLink',
        BUDGET: '.budget',
        BUDGET_BUTTON: '.budget-button',
        BUDGET_HISTORY_BUTTON: '.right-button',
        BUDGET_RECAP_ALMOST_OVER: 'budget-recap-almost-over',
        BUDGET_RECAP_OVER: 'budget-recap-over',
        BUDGET_RECAP_UNDER: 'budget-recap-under',
        CALLOUT: '.calloutMain',
        CARD: '.card',
        CARD_NAME: '.description',
        CARD_NAME_DISPLAY_TEXT: '.card-name-field h1',
        CARD_NAME_INPUT: '#editNameInput',
        CASH_AND_BANKING: 'onboarding-cash-and-banking-view',
        CATEGORY_ANCHOR: 'expensesCategoryAnchor',
        CATEGORY_LIST: 'expensesSubcategoryList',
        CHART: 'cashFlowChartTest',
        CURRENCY_INPUT: '.currency-field input',
        CURRENTLY_SPENT: 'currently-spent',
        DELETE_BUTTON: 'bottomButtons',
        DELETE_NICKNAME_BUTTON: 'deleteNicknameButton',
        DELETE_SAVINGS_GOAL: 'IconLink-delete-savings-goal',
        DIALOG_BOX: 'unenrollDialog',
        DRAWER_HEADING: '.drawerTitle.headingS',
        EDIT_BUDGET_AMOUNT_INPUT: 'currency-field',
        EDIT_INFO_BUTTON: '.personCardBottomRow',
        EDIT_LIFE_EVENT_NAME_LINK: '.cardTop a',
        ESTIMATED_SAVINGS: '#estimatedSavings',
        EXPENSES_EXPAND: 'expensesExpandAnchor',
        EXPENSES_SECTION: 'expensesSection',
        FAMILY_NICKNAME: 'div[role="dialog"] #nickname',
        FINANCIAL_INPUT: '.currency-input-financial div input',
        FREQUENCY_DROPDOWN: 'frequencyDropdown',
        GOALS_AMOUNT_INPUT: '#income',
        HIDE_ACCOUNT_BUTTON: 'hideAccount',
        HIGH_YIELD_SAVINGS_LINK: 'high-yield-savings-link',
        HOME_PRICE_INPUT: '.bwSlider .toggleText a',
        INCOMES_NEXT: '#incomesNext',
        INCOME_AMOUNT_INPUT: 'annualizedIncomeCurrencyInput',
        INCOME_DRAWER: '.incomesDrawer',
        INCOME_INPUT: 'incomeCurrencyInput',
        INCOME_INPUT_LABEL: 'incomeCurrencyInputLabel',
        INCOME_SECTION: 'incomeSection',
        INCOME_SOURCE_SELECT: '#incomeSourceId',
        INSIGHTS_ADD_ACCOUNT: 'insights-add-account-anchor',
        INSIGHTS_BUDGET_ANCHOR: 'insights-planactions-budgets-anchor',
        INSIGHTS_LIFE_EVENTS: 'insights-life-events-anchor',
        INSIGHTS_MAIN_BUTTON: 'insights-main-button',
        INSIGHTS_MAIN_VIEW: 'insights-main-view',
        INSIGHTS_SAVINGS_GOAL: 'insights-savings-goal-anchor',
        INSIGHTS_VIEW_BUDGETS: 'insights-budgets-anchor',
        INSIGHTS_VIEW_PROJECTIONS: 'insights-view-projections-anchor',
        INVESTMENTS_AND_RETIREMENT: 'onboarding-investments-and-retirement-view',
        INVESTMENT_DRAWER: 'investmentDrawer',
        JOB_PICKER: 'jobPicker',
        LARGE_PURCHASE_COST_INPUT: '#large-purchase-slider-input',
        LEARN_ABOUT_LINK: 'savings-learn-about-link',
        LEARN_MORE: 'expensesLearnMoreAnchor',
        LOANS_AND_DEBTS: 'onboarding-loans-and-debts-view',
        LOAN_15_YEAR_RADIO_BUTTON: '#mortgage-15',
        METRIC_CONTAINER: 'metricContainer',
        METRIC_HEADER: 'metricHeader',
        MONTE_BUTTONS: 'fieldset>div',
        MONTE_CARLO: 'monteCarloDiv',
        NAME: '.personName',
        NAME_INPUT: 'name-input',
        NETWORTH_TABLE: 'netWorthTable',
        NEW_SCENARIO_BUTTON: '.scenarioMenuContainer button',
        NEW_TRANSACTIONS_CARD: 'newTransactionsCard',
        NEW_TRANSACTIONS_LINK: 'insights-new-transactions-anchor',
        NEXT_BUTTON: 'onboardingNextButton',
        NICKNAME_INPUT: 'nicknameBasicInput',
        NONTAX_INCOME_CHECKBOX: 'nonTaxIncomeCheckbox',
        OVERALL_BUDGET_CURRENCY_INPUT: 'overall-budget-currency-input',
        OVERVIEW_BUTTONS: 'statsCardBottomRow',
        OVERVIEW_STATS: '.statsTopText',
        PAGE_TITLE: '.drawerTitle',
        PERSON_DIALOG: '.personDialog',
        PERSON_ONE: '.person-1',
        PERSON_RELATIONSHIP: '.personRelationship',
        PER_MONTH_INPUT: '#monthlyCurrencyInput',
        PLAN_ACTIONS_BUDGETS_CLOSE: 'budgetsClose',
        PLAN_ACTIONS_BUDGETS_OVER: 'budgetsOver',
        PLAN_ACTIONS_DANGER_SECTION: 'dangerSection',
        PLAN_ACTIONS_INSTITUTION_WARNINGS: 'institutionWarnings',
        PLAN_ACTIONS_REVIEW_TRANSACTIONS_SECTION: 'reviewTransactionsSection',
        PLAN_ACTIONS_SAVINGS_MISSING_ACCOUNTS: 'savingsMissingAccounts',
        PLAN_ACTIONS_SAVINGS_NOT_DONE: 'savingsNotDone',
        PLAN_NAME: '.plan-intro',
        PROFILE_BUTTON: '.act-button',
        PROFILE_DRAWER: '.financialProfileContainer',
        PROJECTED_DEBT_SECTION: 'projectedDebtSection',
        PROJECTED_EXPENSES_SECTION: 'projectedExpensesSection',
        PROJECTED_INCOME_SECTION: 'projectedIncomeSection',
        PROJECTED_LIQUID_ASSETS_SECTION: 'projectedLiquidAssetsSection',
        PROJECTED_RESTRICTED_ASSETS_SECTION: 'projectedRestrictedAssetsSection',
        PROPERTY_AND_ASSETS: 'onboarding-property-and-assets-view',
        PURCHASE_NAME: '#purchase-name',
        RELATIONSHIP: '#relationship',
        RELATIONSHIP_SELECT: 'relationshipDropdown',
        REMOVE_BUDGET_BUTTON: 'remove-budget-button',
        REMOVE_BUTTON: 'removeButton',
        REPORT_BAR: 'reportBar',
        REPORT_BAR_TITLE: 'reportBarTitle',
        REPORT_DRAWER: 'reportDrawer',
        REPORT_OVERVIEW: 'reportOverview',
        SAVE_BUDGET_BUTTON: '#save-budget',
        SAVE_NAME_BUTTON: 'cardNameEditButtons',
        SAVE_NICKNAME_BUTTON: 'saveNicknameButton',
        SAVINGS_AMOUNT_INPUT: 'savings-amount-input',
        SAVINGS_GOAL_PROGRESS: '.progressBarLabels :last-child',
        SAVING_DETAILS: '.savingsDetails',
        SCENARIO_CREATE_BUTTON: '.scenarioDialogButtonBar .applyButton',
        SCENARIO_CREATE_EMPTY: '.newScenarioDialogContainer .scenarioCreateEmpty',
        SEE_ALL_TRANSACTIONS: 'seeAllTransactions',
        SHOW_ACCOUNT_BUTTON: 'showAccount',
        SHOW_CATEGORIES_TOGGLE: 'childToggle',
        SHOW_HIDE_DETAILS: 'IconLink-show-hide-saving-details',
        SHOW_WORK_BAR_HOVER: '.showWorkDiv',
        SLIDER_TOGGLE: 'sliderToggle',
        STATSBOX_INVESTMENTS_SECTION: 'investmentsSection',
        STATSBOX_NET_WORTH_SECTION: 'netWorthSection',
        STATSBOX_SAVINGS_SECTION: 'savingsSection',
        STATS_CARD_LINKS: 'statsCardBottomRow',
        SUBCATEGORY_ANCHOR: 'expensesSubcategoryAnchor',
        SUBMIT_BUTTON: 'bottomButtons :first-child',
        SUB_EXPENSE: 'subExpense',
        SUB_EXPENSE_TITLE: 'subExpenseTitle',
        SUB_ROW: 'subRow',
        TEXT: '.text',
        TOP_DEPOSITS_SECTION: 'topDepositsSection',
        TOP_DEPOSITS_TO_DATE_SECTION: 'topDepositsToDateSection',
        TOP_DEPOSIT_CARD: 'topDepositCard',
        TOP_DEPOSIT_LINK: 'insights-top-deposit-anchor',
        TOP_EXPENSES_SECTION: 'topExpensesSection',
        TOP_EXPENSES_TO_DATE_SECTION: 'topExpensesToDateSection',
        TOP_EXPENSE_CARD: 'topExpenseCard',
        TOP_EXPENSE_LINK: 'insights-top-expense-anchor',
        TRANSACTION_OVERVIEW: 'transactionOverview',
        TRANSACTION_OVERVIEW_TITLE: 'transactionOverviewTitle',
        TRANSACTION_TEXT: '.brand_b9812',
        UPDATE_BUDGET_BUTTON: 'updateButton',
        UPDATE_BUTTON: '.bottomButtons :first-child',
        VACATION_COST_INPUT: '#vacation-cost-slider-input'
    },
    SpendSmart: {
        ACCOUNT_ROW: 'accountRow',
        ACCOUNT_ROW_BALANCE: 'accountRowBalance',
        ACCOUNT_ROW_SUBTITLE: 'accountRowSubtitle',
        ACCOUNT_ROW_TITLE: 'accountRowTitle',
        ADD_CATEGORY_BUTTON: 'BudgetPersonalizeView-addCategoryButton',
        ADD_EXTERNAL_ACCOUNT_BUTTON: 'addExternalAccountButton',
        AMOUNT_CALLOUT: 'amountCallout',
        AMOUNT_REMAINING: 'amountRemaining',
        AMOUNT_REMAINING_PILL: 'amountRemainingPill',
        AMOUNT_REMAINING_TITLE: 'amountRemainingTitle',
        AMOUNT_SPENT: 'amountSpent',
        APPROVE_BUTTON: 'approveButton',
        BASIC_INPUT_ERROR: 'BasicInputError',
        BASIC_INPUT_FIELD: 'BasicInputField',
        BUDGET_AMOUNT: 'BudgetAmount',
        BUDGET_STATS_BOX: 'budgetStatsBox',
        BUDGET_TRACKER_CARD: 'budgetProgressCard',
        BUDGET_TRACKER_CARD_BAR: 'budgetTrackerCardBar',
        BUDGET_VIEW: 'transactionsBudgetView',
        CALLOUT_ANCHOR: 'calloutAnchor',
        CALLOUT_BODY: 'calloutBody',
        CALLOUT_BUTTON: 'calloutButton',
        CALLOUT_HEADER: 'calloutHeader',
        CALLOUT_ICON: 'calloutIcon',
        CARD: 'transactionsCard',
        CAROUSEL_NAVIGATION: 'carousel',
        CATEGORY_BASED_SPENDING: 'categoriesSpendingTotal',
        CATEGORY_CARD: 'categoryCard',
        CATEGORY_CARD_COLLAPSIBLE_MENU: 'categoryCardCollapsibleMenu',
        CATEGORY_CARD_COLLAPSIBLE_SKELETON: 'categoryCardCollapsibleSkeleton',
        CATEGORY_CARD_GRID: 'categoryCardGrid',
        CATEGORY_CARD_SKELETON_GRID: 'categoryCardSkeletonGrid',
        CATEGORY_HISTORY_MODAL: 'categoryHistoryModal',
        CATEGORY_HISTORY_MODAL_TITLE: 'categoryHistoryModalHeader',
        CATEGORY_OVER_SPENDING_WARNING_BANNER: 'categoryOverSpendingWarningBanner',
        CHART_TIME_PERIOD: 'chartTimePeriod',
        CLOSE_BUTTON: 'closeButton',
        COLORED_PROGRESS_BAR: 'coloredProgressBar',
        CONFIRM_BUTTON: 'confirmButton',
        DASHBOARDMODAL: 'dashboardModal',
        DASHBOARDMODAL_IMAGE: 'dashboardModalDialogBoxImage',
        DASHBOARDMODAL_LISTITEM: 'dashboardModalListItem',
        DASHBOARDMODAL_LISTITEM_CONTENT: 'dashboardModalListItemContent',
        DASHBOARDMODAL_LISTITEM_TITLE: 'dashboardModalListItemTitle',
        DASHBOARDMODAL_TITLE: 'dashboardModalTitle',
        DATE_RANGE_INPUT: 'dateRangeInput',
        DATE_RANGE_INPUT_ERROR: 'dateRangeInputError',
        DATE_RANGE_MODAL: 'dateRangeModal',
        DELETE_BUTTON: 'deleteButton',
        DELETE_NICKNAME_BUTTON: 'deleteNicknameButton',
        DETAILS_VIEW: 'transactionDetailsView',
        DIALOG_BOX_BODY: 'dialogBoxBody',
        DIALOG_BOX_HEADER: 'dialogBoxHeader',
        DROPDOWN_ERROR: 'dropdownError',
        EMAIL_PREFERENCES_COMPONENT: 'emailPreferencesComponent',
        EMAIL_PREFERENCES_COMPONENT_BOTTOM_SECTION: 'emailPreferencesComponentBottomSection',
        EMAIL_PREFERENCES_COMPONENT_ERROR: 'emailPreferencesComponentError',
        EMAIL_PREFERENCES_COMPONENT_LINK: 'emailPreferencesComponentLink',
        EMAIL_PREFERENCES_COMPONENT_LOADING: 'emailPreferencesComponentLoading',
        EMAIL_PREFERENCES_COMPONENT_TITLE: 'emailPreferencesComponentTitle',
        EMAIL_PREFERENCES_COMPONENT_TOP_SECTION: 'emailPreferencesComponentTopSection',
        EMAIL_PREFERENCE_ROW: 'emailPreferenceRow',
        EMAIL_PREFERENCE_ROW_SUBTITLE: 'emailPreferenceRowSubtitle',
        EMAIL_PREFERENCE_ROW_TITLE: 'emailPreferenceRowTitle',
        EMPTY_CHART: 'emptyChart',
        EXPENSE_TAB: 'expenseTab',
        EXTERNAL_ACCOUNT_CALLOUT: 'externalAccountCallout',
        HISTORY_BUTTON: 'ProgressIconsHistoryLink',
        HISTORY_DIFFERENCE_AMOUNT: 'historyTableDifferenceAmount',
        HISTORY_DIFFERENCE_LABEL: 'historyTableDifferenceLabel',
        HISTORY_MONTH_NAME_LINK: 'monthNameLink',
        HISTORY_MONTH_ROW_DESKTOP: 'historyTableMonthRowDesktop',
        HISTORY_MONTH_ROW_MOBILE: 'historyTableMonthRowMobile',
        HISTORY_ROOT: 'BudgetHistoryView',
        HISTORY_TABLE: 'budgetHistoryTable',
        HISTORY_TABLE_AMOUNT: 'historyTableAmount',
        HOME_EDIT_BUDGET_BUTTON: 'editButton',
        HOME_ROOT: 'BudgetIndexView',
        ICON_CONTAINER_PARENT: 'iconContainerParent',
        ICON_CONTAINER_SUBCATEGORY: 'iconContainerSubcategory',
        INCOME_TAB: 'incomeTab',
        INFO_BOX: 'infoBox',
        INFO_BOX_TEXT: 'infoBoxText',
        INFO_ICON: 'infoIcon',
        INFO_MODAL: 'infoModal',
        INFO_MODAL_CLOSE: 'infoModalClose',
        INFO_MODAL_CONTENT: 'infoModalContent',
        INFO_MODAL_OPEN: 'infoModalOpen',
        LINK_EXTERNAL_ACCOUNT_ANCHOR: 'linkExternalAccountAnchor',
        LINK_EXTERNAL_ACCOUNT_BODY: 'linkExternalAccountBody',
        MONTHLY_AVERAGE_BOX: 'MonthlyAverageBox-amount',
        MONTHLY_AVERAGE_BOX_LINK: 'monthlyAverageBoxLink',
        MONTHLY_BUDGET_HEADING: 'monthlyBudgetHeading',
        MONTHLY_BUDGET_PROGRESS_CARD: 'monthlyBudgetProgressCard',
        MONTHLY_SPENDING_BUDGET: 'monthlySpendingBudget',
        MONTHLY_SPENDING_BUDGET_HEADER: 'monthlySpendingBudgetHeader',
        MONTHLY_SPENDING_TITLE: 'BudgetPersonalizeView-monthlySpendingTitle',
        MONTHLY_SPEND_BUTTON: 'BudgetPersonalizeView-monthlySpendButton',
        NAME_EDIT_BUTTON: 'nicknameEditButton',
        NEXT_BUTTON: 'nextButton',
        NICKNAME_EDIT: 'nicknameEditBox',
        NUM_ACCOUNT_LINK: 'numAccountsLink',
        OPEN_BUTTON: 'openButton',
        PERSONALIZE_CANCEL_BUTTON: 'personalizeCancelButton',
        PERSONALIZE_CATEGORY_HEADER: 'personalizeCategoryHeader',
        PERSONALIZE_CONFIRM_BUTTON: 'personalizeConfirmButton',
        PERSONALIZE_ROOT: 'BudgetPersonalizeView',
        POPUP: 'popup',
        POPUP_PROGRESS_TEXT: 'popupProgressText',
        POPUP_TOOLTIP: 'popupTooltip',
        PROGRESS_BAR: 'progressBar',
        PROGRESS_BAR_TOOLTIP: 'progressBarTooltip',
        ROW: 'budgetCategoryRow',
        SAVE_NICKNAME_BUTTON: 'saveNicknameButton',
        SECONDARY_NAVIGATION: 'secondaryNavigation',
        SECONDARY_NAVIGATION_DROPDOWN: 'secondaryNavigationDropdown',
        SECONDARY_NAVIGATION_DROPDOWN_BUTTON: 'secondaryNavigationDropdownButton',
        SELECT: 'select',
        SELECT_DETAILED: 'SelectDetailed',
        SELECT_DETAILED_ERROR: 'selectDetailedError',
        SELECT_DETAILED_OPTIONS: 'selectDetailedOptions',
        SELECT_DETAILED_SEARCH: 'selectDetailedSearch',
        SELECT_OPTION: 'selectOption',
        SELECT_OPTION_ICON: 'selectOptionIcon',
        SELECT_OPTION_TEXT: 'selectOptionText',
        SETTINGS_ROOT: 'BudgetSettingsView',
        SHOW_SUBCATEGORY_BUTTON: 'showSubcategoryButton',
        SHOW_SUBCATEGORY_BUTTON_DISABLED: 'showSubcategoryButtonDisabled',
        SKIP_BUTTON: 'skipButton',
        SLIDER_DIALOG_BOX: 'sliderDialogBox',
        SLIDER_DIALOG_BOX_BODY: 'sliderDialogBoxBody',
        SLIDER_DIALOG_BOX_HEADER: 'sliderDialogBoxHeader',
        SLIDER_DIALOG_BOX_IMAGE: 'sliderDialogBoxImage',
        SPENDING_BREAKDOWN_AVERAGE_MONTHLY_SPENT: 'spendingBreakdownAverageMonthlySpent',
        SPENDING_BREAKDOWN_SPENT: 'spendingBreakdownSpent',
        SPENDING_CATEGORY_HISTORY: 'spendingHistoryCategory',
        SPENDING_HISTORY_CHART: 'spendingHistoryChart',
        SPENDING_HISTORY_CHART_MONTHLINK: 'spendingHistoryChartMonthLink',
        SPENDING_LINE_GRAPH: 'spendingLineGraph',
        SPENDING_OVERVIEW_CATEGORY: 'spendingOverviewCategory',
        SPENDING_OVERVIEW_PERCENT_SPENT: 'spendingOverviewPercentSpent',
        SPENDING_SUM_CHILD_ROW: 'spendingSumChildRow',
        SPENDING_SUM_COLLAPSIBLE: 'spendingSumCollapsible',
        SPENDING_SUM_EXPAND_BUTTON: 'spendingSumExpandButton',
        SPENDING_SUM_GRID_CURRENT_MONTH_HEADER: 'spendingSumGridCurrentMonthHeader',
        SPENDING_SUM_GRID_HISTORY_HEADER: 'spendingSumGridHistoryHeader',
        SPENDING_SUM_PARENT_ROW: 'spendingSumParentRow',
        SPENDING_SUM_ROW_AVERAGE: 'spendingSumRowAverage',
        SPENDING_SUM_ROW_PERCENT: 'spendingSumRowPercent',
        SPENDING_SUM_ROW_SPENT: 'spendingSumRowSpent',
        SPENT_REMAINING: 'spentRemaining',
        STATS_BOX: 'budgetStatsBox',
        SUBCATEGORY_BUTTON: 'BudgetCategoryRow-subcategoryButton',
        SUBCATEGORY_LEFT_INDICATOR: 'subcategoryLeftIndicator',
        SUMMARY_STAT_AMOUNT: 'summaryStatAmount',
        SUMMARY_STAT_TITLE: 'summaryStatTitle',
        TARGET_MONTHLY_SPENDING: 'targetMonthlySpending',
        TARGET_MONTHLY_SPENDING_CALLOUT: 'targetMonthlySpendingCallout',
        TARGET_MONTHLY_SPENDING_CALLOUT_BODY: 'targetMonthlySpendingCalloutBody',
        TARGET_MONTHLY_SPENDING_CALLOUT_HEADER: 'targetMonthlySpendingCalloutHeader',
        TARGET_MONTHLY_SPENDING_INPUT: 'targetMonthlySpendingInput',
        TARGET_MONTHLY_SPENDING_MODAL: 'targetMonthlySpendingModal',
        TARGET_MONTHLY_SPENDING_MODAL_HEADER: 'targetMonthlySpendingModalHeader',
        TARGET_MONTHLY_SPENDING_MONTHLY_AVERAGE_SUBTEXT: 'targetMonthlySpendingMonthlyAverageSubtext',
        TARGET_MONTHLY_SPENDING_STATS_BOX: 'targetMonthlySpendingStatsBox',
        TOGGLE_ACCOUNTS_BUTTON: 'ToggleAccountRow-toggleButton',
        TOGGLE_EMAIL_PREFERENCES_BUTTON: 'ToggleEmailPreferencesRow-toggleButton',
        TOTAL_AVERAGE_MODAL: 'totalAverageModal',
        TOTAL_AVERAGE_MODAL_CONTENT: 'totalAverageModalContent',
        TRACKER_HEADER: 'trackerHeader',
        TRACKER_HEADER_AMOUNT: 'trackerHeaderAmount',
        TRACKER_HEADER_ICON: 'trackerHeaderIcon',
        TRACKER_HEADER_TITLE: 'trackerHeaderTitle',
        UNENROLL_DIALOG: 'unenrollDialog',
        VIEW_CURRENT_MONTH_TRANSACTIONS_LINK: 'viewCurrentMonthTransactionsLink',
        VIEW_TRANSACTIONS_LINK: 'viewTransactionsLink',
        WARNING_DIALOG: 'warningDialog',
        WARNING_DIALOG_TEXT: 'warningDialogText',
        WELCOME_SLIDER: 'welcomeSlider',
        WELCOME_SLIDER_IMAGE: 'welcomeSliderImage',
        WRONG_NUMBERS_CALLOUT: 'wrongNumbersCallout'
    },
    Transactions: {
        ADD_ASSET_BUTTON: '#add-asset',
        AMOUNT_VALUE: 'amountValue',
        APPLY_RULE_BUTTON: 'applyRuleButton',
        BULK_APPROVE_BANNER: 'bulkApproveBanner',
        BULK_APPROVE_BUTTON: 'bulkApproveButton',
        BULK_CATEGORY_SELECT_DETAILED: 'changeToGroupUidSelectDetailed',
        BULK_EDIT_CHANGE_CATEGORY_SOURCE_BUTTON: 'bulkEditChangeCategorySourceButton',
        BULK_EDIT_CHANGE_FREQUENCY_BUTTON: 'bulkEditChangeFrequencyButton',
        BULK_EDIT_CONTAINER: 'transactionsBulkEdit',
        BULK_FREQUENCY_SELECT_DETAILED: 'changeFrequencySelectSelectDetailed',
        BULK_INCOME_SOURCE_SELECT_DETAILED: 'changeToIncomeUidSelectDetailed',
        CARD_ROW: 'transactionsCardRow',
        CATEGORY_SELECT_DETAILED: 'groupUidSelectDetailed',
        CHANGE_CATEGORY_MODAL: 'changeCategoryModal',
        CHANGE_FREQUENCY_MODAL: 'changeFrequencyModal',
        CLOSE: 'transactionsCloseSelect',
        CREATE_RULE_BOX: 'createRuleBox',
        CREATE_RULE_BUTTON: 'createRuleButton',
        CREATE_RULE_HEADER: 'createRuleHeader',
        CREATE_TRANSACTION_RULE_PROMPT: 'createTransactionRuleBox',
        CREATE_UPDATE_RULE: 'createUpdateRule',
        CUSTOM_SUBCATEGORY_MODAL: 'customSubcategoryModal',
        CUSTOM_SUBCATEGORY_NAME_INPUT: 'customSubcategoryNameBasicInput',
        CUSTOM_SUBCATEGORY_NAME_INPUT_ERROR: 'customSubcategoryNameBasicInputError',
        ControlLabel: '#toggleSwitch',
        DATE: 'date',
        DATE_COLUMN: 'date-column',
        DATE_VALUE: 'dateValue',
        DELETE_RULE_BUTTON: 'deleteRuleButton',
        DETAILS: '#transactionDetails',
        DETAILS_BACK_LINK: 'transactionDetailsBackLink',
        DRAG_AND_DROP_RULES: 'dragAndDropRules',
        DRAG_ICON: 'dragIcon',
        DRAG_RULE: 'dragRule',
        EDIT_TRANSACTION_BUTTON: 'editTransactionButton',
        EMPTY_STATE_BOX_DESC: 'transactionsEmptyStateDesc',
        FILTER_CONTAINER: 'transactionFilter',
        FILTER_MENU: 'transactionFilterMenu',
        FILTER_SUB_MENU: 'transactionFilterSubMenu',
        FILTER_TAG: 'transactionFilterTag',
        FREQUENCY_SELECT_DETAILED: 'frequencySelectDetailed',
        HEADER_PANEL: '.header-panel',
        INCOME_SELECT_DETAILED: 'incomeUidSelectDetailed',
        INCOME_SOURCE_MODAL: 'incomeSourceModal',
        INCOME_SOURCE_NAME_INPUT: 'incomeSourceNameBasicInput',
        INFO: '#linkAddRule',
        MANAGE_RULES: 'manageRulesButton',
        MANAGE_RULES_HEADER: 'manageRulesHeader',
        MANAGE_RULES_HEADER_DESCRIPTION: 'manageRulesHeaderDescription',
        MANAGE_RULES_HEADER_TITLE: 'manageRulesHeaderTitle',
        MATCHING_RULES: 'matchingRules',
        NAME: 'transactionName',
        NAME_COLUMN: 'nameColumn',
        NAME_LINK: '#nameLink',
        NAME_VALUE: 'nameValue',
        NEVER_ASK_TO_CREATE_RULE_BUTTON: 'neverAskToCreateRuleButton',
        NO_OF_REVIEW_TRANSACTIONS: 'reviewTransactionsBanner',
        NO_OF_TRANSACTIONS: 'noOfTransactions',
        OCCURANCE: 'occurence-column',
        PAGINATION: 'transactionsTablePagination',
        REVIEW_BANNER: 'reviewTransactionsBanner',
        REVIEW_EMPTY_STATE: 'reviewTransactionsEmptyState',
        REVIEW_ROW: 'transactionReviewTableRow',
        REVIEW_VIEW: 'transactionsReviewView',
        RULE: '#transactionsRules',
        RULE_ALREADY_EXISTS_ERROR: 'ruleAlreadyExistsError',
        RULE_CATEGORY: 'ruleCategory',
        RULE_EMPTY_STATE_DESC: 'rulesEmptyStateDesc',
        RULE_MATCHER: 'ruleMatcher',
        RULE_NAME: 'ruleTransactionName',
        RULE_PROMPT: 'rulePrompt',
        RULE_PROMPT_NEVER_ASK: 'rulePromptNeverAsk',
        RULE_PROMPT_SUCCESS: 'rulePromptSuccess',
        RULE_ROW: 'ruleRow',
        RULE_SELECT: 'ruleGroup',
        RULE_SETTING: 'ruleSetting',
        RULE_SETTING_TOGGLE_BUTTON: 'ruleSettingToggle',
        RULE_TYPE_DROPDOWN: 'ruleTypeDropdown',
        RULE_VIEW: 'transactionRulesView',
        SEARCH: 'transactionSearch',
        SELECT_ALL_CHECKBOX: 'transactionsSelectAllCheckbox',
        SHOW_IGNORED_TOGGLE: 'showIgnoredToggle',
        TABLE_CONTAINER: 'transactionsTable',
        TABLE_HEADER_ROW: 'transactionsTableHeaderRow',
        TABLE_HEADER_ROW_BUTTONS: {
            AMOUNT: '#amount button',
            CATEGORY: '#category button',
            DATE: '#date button',
            NAME: '#name button',
            TYPE: '#type button'
        },
        TABLE_ROW: 'transactionTableRow',
        TOTAL_CASH_FLOW: 'cashFlowStat',
        TOTAL_EXPENSES: 'expensesStat',
        TOTAL_INCOME: 'incomeStat',
        TOTAL_TRANSFER_IN: 'transferInStat',
        TOTAL_TRANSFER_OUT: 'transferOutStat',
        TRANSACTIONS_TABLE: 'unifiedTransactionsTable',
        TRANSACTIONS_TABLE_HEADER_CHECKBOX: 'transactionsTableHeaderCheckbox',
        TRANSACTION_TABLE_CHECKBOX: 'transactionsTableCheckbox',
        TRANSACTION_TH: 'transactionsDiv',
        TYPE_COLUMN: 'typeColumn',
        TYPE_FILTER: 'typeFilter',
        TYPE_VALUE: 'typeValue',
        UNDO_NEVER_ASK: 'undoNeverAsk',
        UNDO_RULE: 'undoRule',
        VIEW: 'transactionsBudgetView',
        VIEW_ALL_TRANSACTIONS: 'viewAllTransactions'
    }
};
